/*** IMPORTS FROM imports-loader ***/
var define = false;

import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/weak-map';
import 'core-js/es/array/from';
import 'core-js/es/object/assign';
//# sourceMappingURL=polyfills.js.map
